import './i18n';
import { createRoute } from '@tanstack/react-router';
import type { EzyModule } from '../module';
import { ImportList } from './ImportList';
import {
  CLAIMS, CONTAINERS, DECLS, DEPOSITS, HS_CANDIDATES, HS_FTAS, HS_PENDING, HS_RECENT, REEFERS, SHIPMENTS,
} from './fixtures';

// G-04a: Hàng nhập (Mint-Import). Tư vấn HS / Số liệu hải quan thêm ở G-06.
const customs: EzyModule = {
  // Menu: mục "Hàng nhập & cont" nằm trong nhóm Chứng từ & B/L (docs/module.ts) — không thêm nhóm mới.
  routes: (parent) => [createRoute({ getParentRoute: () => parent, path: '/import', component: ImportList })],
  fixtures: (register) => {
    register('importShipment', SHIPMENTS);
    register('importContainerFree', CONTAINERS);
    register('importDecl', DECLS);
    register('importReefer', REEFERS);
    register('importDeposit', DEPOSITS);
    register('importClaim', CLAIMS);
    register('hsCandidate', HS_CANDIDATES);
    register('hsFta', HS_FTAS);
    register('hsRecent', HS_RECENT);
    register('hsPending', HS_PENDING);
  },
};
export default customs;
